var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 49,
    viewBox: "0 0 119 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000204623 34.1161C-0.000204623 34.1161 1.45358 22.9881 1.99895 18.1387C2.53849 13.3247 3.13778 -0.000333891 3.13778 -0.000333891C3.13778 -0.000333891 34.0277 2.10758 49.3484 5.28397C58.0344 7.08482 85.7282 9.28754 90.6847 10.1052C95.6413 10.9228 109.814 12.7158 111.731 12.9232C113.649 13.1305 118.344 13.2151 118.344 13.2151C118.344 13.2151 117.795 25.2912 116.865 29.3871C115.934 33.4829 115.335 40.9747 115.443 41.8641C115.551 42.7536 114.777 48.219 114.777 48.219C114.777 48.219 81.3468 44.5931 76.5667 43.4777C71.7865 42.3623 44.6609 40.9022 36.5764 39.2417C28.4918 37.5812 19.5063 36.7528 11.8129 36.0648C4.11956 35.3768 -0.000204623 34.1161 -0.000204623 34.1161Z",
    fill: "#674CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutTimer);
export default __webpack_public_path__ + "static/media/checkout-timer.3f5f976b81128169c6264b5a50592b43.svg";
export { ForwardRef as ReactComponent };